import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // collapse styles
  header: {
    borderTop: `1px solid ${theme.colorPalette.green_75_40}`,
    borderRadius: 0,
    minHeight: 'unset',
    height: 48
  },
  content: {
    padding: 0
  },
  iconButtonRoot: {
    top: 0,
    right: 0
  },
  collapse: {
    minHeight: '48px !important',
    height: 'unset !important'
  },
  container: {
    minHeight: 'unset',
    boxShadow: 'none'
  },
  singleBottom: {
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end'
  }
});

export default makeStyles(styles);
